import { ASSETS, THUMB_PREFIX, THUMB_SUFFIX_SVG } from '../constants/Constants';
export class ThumbnailsHelper {
    /**
     * Helper method to get the default thumbnail path
     * @param {string} assetType
     * @param {string} extension
     * @returns {string}
     */
    static getDefaultThumb(assetType, extension) {
        const thumb = ThumbnailsHelper.getThumbName(assetType, extension);
        const suffix = THUMB_SUFFIX_SVG;
        return `${THUMB_PREFIX}${thumb}${suffix}`;
    }
    /**
     * helper method to get the right thumb filename
     * @param {string} assetType
     * @param {string} extension
     * @returns {string}
     */
    static getThumbName(assetType, extension) {
        let thumbName = 'undefined';
        if (assetType === ASSETS.DOCUMENT.NAME) {
            // document
            const DOCUMENT = ASSETS.DOCUMENT;
            /* eslint-disable indent */
            switch (extension) {
                case DOCUMENT.EXCEL.EXT.XLS:
                case DOCUMENT.EXCEL.EXT.XLSX:
                    thumbName = DOCUMENT.EXCEL.NAME;
                    break;
                case DOCUMENT.DOCUMENT.EXT.DOC:
                case DOCUMENT.DOCUMENT.EXT.DOCX:
                    thumbName = DOCUMENT.DOCUMENT.NAME;
                    break;
                case DOCUMENT.PRESENTATION.EXT.PPT:
                case DOCUMENT.PRESENTATION.EXT.PPTX:
                case DOCUMENT.PRESENTATION.EXT.KEY:
                case DOCUMENT.PRESENTATION.EXT.KEYNOTE:
                    thumbName = DOCUMENT.PRESENTATION.NAME;
                    break;
                case DOCUMENT.PDF.EXT.PDF:
                    thumbName = DOCUMENT.PDF.NAME;
                    break;
                case DOCUMENT.AUTOCAD.EXT.CAD:
                case DOCUMENT.AUTOCAD.EXT.DWG:
                    thumbName = extension;
                    break;
                case DOCUMENT.DEFAULT.EXT.EPUB:
                case DOCUMENT.DEFAULT.EXT.IBOOKS:
                case DOCUMENT.DEFAULT.EXT.PAGES:
                default:
                    thumbName = DOCUMENT.NAME;
            }
            /* eslint-enable indent */
        }
        else {
            thumbName = ASSETS[assetType.toUpperCase()].NAME;
        }
        return thumbName;
    }
}
//# sourceMappingURL=ThumbnailsHelper.js.map